import axios from "axios";

const checkNull = time => {
  if (time == "null" || time == "undefined") {
    return null;
  }

  return time;
};

const apiFunc = {
  getBlockHeight: _ => {
    return axios.get("/blockheight");
  },

  getTotalTx: _ => {
    return axios.get("/tx/total");
  },

  getTransactionsHistory: _ => {
    return axios.get("/tx/history");
  },

  getRecentBlocks: _ => {
    return axios.get("/recentblocks");
  },

  getRecentTxs: _ => {
    return axios.get("/recenttxs");
  },

  getBlocks: ({ from_time, to_time, bookmark, pagesize, direction }) => {
    return axios.get("/blocks", {
      params: {
        from_time,
        to_time,
        bookmark,
        pagesize,
        direction,
      }
    });
  },

  getTxs: ({ from_time, to_time, function_name, bookmark, pagesize, direction }) => {
    return axios.get(`/txs`, {
      params: {
        from_time,
        to_time,
        function_name,
        bookmark,
        pagesize,
        direction,
      }
    });
  },

  getTxsOfBlock: ({ bookmark, pagesize, direction, block_num }) => {
    return axios.get(`/blocktxs/${block_num}`, {
      params: {
        bookmark,
        pagesize,
        direction
      }
    });
  },

  getBlockDetail: id => {
    return axios.get(`/blocks/${id}`);
  },

  getTxDetail: id => {
    return axios.get(`/txs/${id}`);
  },

  getAccount: id => {
    return axios.get(`/accounts/${id}`);
  },

  getTransfersOfAccount: ({ bookmark, pagesize, direction, address }) => {
    return axios.get(`/accounts/${address}/transfers`, {
      params: {
        bookmark,
        pagesize,
        direction
      }
    });
  },

  getCirculating: _ => {
    return axios.get("/circulating");
  },
  getAddressCheck: address => {
    return axios.get(`/unwrap/${address}`);
  },
  getRichAccounts: _ => {
    return axios.get("/richaccounts");
  },
};

// 서버가 준 에러 응답을 안전하게 해석한다.
// - NotFound 등 일부 에러는 message가 JSON 문자열({"error_code":"1000",...})이다.
// - ValidationParams 등은 message가 평문("Invalid Params : ...")이라 JSON.parse가 실패한다.
// - 네트워크 오류/타임아웃은 response 자체가 없다.
// 어느 경우에도 예외를 던지지 않고 truthy한 errCode를 돌려주어,
// 호출부가 로딩 상태를 정리할 수 있게 한다.
const extractErrCode = e => {
  const message = e && e.response && e.response.data && e.response.data.message;

  if (!message) {
    return (e && e.message) || "network error";
  }

  try {
    const parsed = JSON.parse(message);
    return parsed.error_code || message;
  } catch (_) {
    return message;
  }
};

export default async (funcName, param) => {
  let result = {
    data: {},
    errCode: ""
  };

  try {
    const { data } = await apiFunc[funcName](param);
    result.data = data;
  } catch (e) {
    result.errCode = extractErrCode(e);
  }

  return result;
};



// WEBPACK FOOTER //
// ./src/api/http.js